// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Atom_Box = require("../atom/Atom_Box.bs.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Util_Array = require("../../util/Util_Array.bs.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Particle_Block_Ds = require("./Particle_Block_Ds.bs.js");
var Particle_Screen_Css = require("./Particle_Screen_Css.bs.js");

function wrapRule(wrap) {
  return CssJs.flexWrap("nowrap");
}

function getAutoSizeRules(autoSize) {
  var getAutoSizeRule = function (autoSizeValue) {
    var tmp;
    if (autoSizeValue >= 3) {
      tmp = [];
    } else {
      switch (autoSizeValue) {
        case /* AllPlaceAvailable */0 :
            tmp = [CssJs.width(CssJs.pct(100))];
            break;
        case /* AllPlaceNeeded */1 :
            tmp = [];
            break;
        case /* MaxContent */2 :
            tmp = [CssJs.unsafe("width", "max-content")];
            break;
        
      }
    }
    return Belt_Array.concat(tmp, [Atom_Box.getAutoSizeRule(autoSizeValue)]);
  };
  return Particle_Screen_Css.toRules(undefined, undefined, getAutoSizeRule, autoSize);
}

function toCss(t) {
  var match = Particle_Block_Ds.view(t);
  return Belt_Array.concat(Util_Array.catOption([
                  Belt_Option.map(match.wrap, wrapRule),
                  Belt_Option.map(match.justifyContent, CssJs.justifyContent),
                  Belt_Option.map(match.alignItems, CssJs.alignItems),
                  Belt_Option.map(match.alignSelf, CssJs.alignSelf),
                  Belt_Option.map(match.position, CssJs.position),
                  Belt_Option.map(match.overflow, CssJs.overflow)
                ]), Belt_Option.getWithDefault(Belt_Option.map(match.autoSize, getAutoSizeRules), []));
}

var justifyContentRule = CssJs.justifyContent;

var alignItemsRule = CssJs.alignItems;

var alignSelfRule = CssJs.alignSelf;

var positionRule = CssJs.position;

var overflowRule = CssJs.overflow;

exports.wrapRule = wrapRule;
exports.getAutoSizeRules = getAutoSizeRules;
exports.justifyContentRule = justifyContentRule;
exports.alignItemsRule = alignItemsRule;
exports.alignSelfRule = alignSelfRule;
exports.positionRule = positionRule;
exports.overflowRule = overflowRule;
exports.toCss = toCss;
/* CssJs Not a pure module */
